package com.yendo.mx.models

import kotlinx.serialization.Serializable
import kotlinx.serialization.SerialName

@Serializable
data class InvitacionStaff(
    val idNegocio: String = "",
    val nombreNegocio: String = "",
    val rol: String = "STAFF",
    val estado: String = "pendiente",
    val fecha: Long = 0L
)

@Serializable
data class DispositivoVinculado(
    val id: String = "",
    val nombre: String = "", // Ej: "iPhone de Luis"
    val modelo: String = "", // Ej: "iPhone 13 Pro"
    val sistema: String = "", // Ej: "iOS 17.2"
    val ultimaConexion: Long = 0
)

@Serializable
data class UsuarioYendo(
    val uid: String = "",
    val nombre: String = "",
    val apellido: String = "", // 🚀 NUEVO
    val telefono: String = "",

    @SerialName("email")
    val email: String = "",

    val emailVerificado: Boolean = false,

    // 🚀 --- NUEVO CAMPO: FOTO DE PERFIL ---
    // Este campo es el que necesita PerfilScreen y AuthRepository para no tronar
    val fotoPerfil: String = "",

    val esInvitado: Boolean = false,

    // 🚀 --- CANDADOS DE SEGURIDAD (NUEVOS) ---

    // Switch maestro: Si es true, la cuenta está suspendida por completo
    val bloqueado: Boolean = false,

    // Razón de la suspensión (Ej: "Actividad fraudulenta detectada")
    val motivo_bloqueo: String = "",

    // String separado por comas con métodos prohibidos (Ej: "Efectivo", "Efectivo, Transferencia")
    val metodos_pago_bloqueados: String = "",

    val eliminacion_pendiente: Boolean = false,
    val idNegocioVinculado: String = "",

    val metodosAcceso: List<String> = emptyList(),
    val dispositivosConfiables: List<String> = emptyList(),
    val infoDispositivos: List<DispositivoVinculado> = emptyList(), // 🚀 NUEVO: Metadata para el perfil
    val emailsVinculados: List<String> = emptyList(),

    // 🚀 NUEVOS CAMPOS PARA STAFF
    val invitacionStaff: InvitacionStaff? = null,
    val invitacionNegocio: Map<String, String>? = null, // 🚀 NUEVO: Formato unificado
    val roles: Map<String, Boolean> = emptyMap()
) {
    // Atajo para verificar si es staff rápidamente
    val esStaffNegocio: Boolean get() = roles["esStaffNegocio"] ?: false
    val esRepartidorPropio: Boolean get() = roles["esRepartidorPropio"] ?: false
}
